import { render } from "./testimonials-table.vue?vue&type=template&id=3d232547"
import script from "./testimonials-table.vue?vue&type=script&lang=js"
export * from "./testimonials-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__